import styled from "styled-components";
import CustomButton from "../../CustomButton/CustomButton";

const BodyWrapper = styled.div`
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  width: 100%;
  padding: 10px 10px;
  border-radius: 8px;

  .section {
    margin-top: 20px;

    .section-content {
      display: flex;
      align-items: center;
      margin-top: 10px;
    }

    .section-header {
      font-weight: 700;
      font-size: 16px;
      color: #004576;
    }

    .checkBoxName {
      font-weight: 400;
      font-size: 15px;
      margin-left: 10px;
    }
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const ButtonSecondary = styled.button`
  border: 1px solid #b5cadc;
  border-radius: 4px;
  padding: 5px;
  text-align: center;
  font-weight: 800;
  font-size: 12px;
  color: #004576;
  width: 100%;
`;

const ButtonPrimary = styled.button`
  border: 1px solid #b5cadc;
  border-radius: 4px;
  padding: 5px;
  text-align: center;
  font-weight: 800;
  font-size: 12px;
  color: white;
  background-color: #004576;
  width: 100%;
`;

const FIlterGroupSortContainer = () => {
  return (
    <BodyWrapper>
      <ButtonsContainer>
        <ButtonSecondary>Clear</ButtonSecondary>
        <ButtonPrimary>Apply</ButtonPrimary>
      </ButtonsContainer>
      <div className="section">
        <div className="section-header">Group:</div>
        {[...Array(5)].map((data, index) => (
          <div className="section-content">
            <input type="checkbox" />
            <span className="checkBoxName">Group Item {index + 1}</span>
          </div>
        ))}
      </div>
      <div className="section">
        <div className="section-header">Filter:</div>
        {[...Array(5)].map((data, index) => (
          <div className="section-content">
            <input type="checkbox" />
            <span className="checkBoxName">Filter Item {index + 1}</span>
          </div>
        ))}
      </div>
      <div className="section">
        <div className="section-header">Sort:</div>
        {[...Array(5)].map((data, index) => (
          <div className="section-content">
            <input type="checkbox" />
            <span className="checkBoxName">Sort Item {index + 1}</span>
          </div>
        ))}
      </div>
    </BodyWrapper>
  );
};

export default FIlterGroupSortContainer;
